import { cn } from "@gymflow/helpers";
import { useQueryNextCalendarEventOccurrencesAsPublic } from "libs/api/src/lib/hooks/calendarAsPublic/useQueryNextCalendarEventOccurrencesAsPublic";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import useGymflowModels from "../../../store";
import { Spinner } from "../../atoms";
import HostedPagesClassCard from "../../site/HostedPagesClasses/components/HostedPagesClassCard";
import { AppSettingsContext } from "./AppSettingsContext";

export const AppClassPreview = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { data, isLoading } = useQueryNextCalendarEventOccurrencesAsPublic({
    api,
  });
  const { classesLocalData } = useContext(AppSettingsContext);
  if (!classesLocalData) return null;
  return (
    <div
      className={cn(
        "flex size-full items-center justify-center rounded-3xl bg-gray-100 p-6",
        className,
      )}
    >
      {isLoading && <Spinner />}
      {!isLoading && !data?.content?.[0] && (
        <div className="flex flex-col items-center justify-center font-bold text-gray-950">
          {t("page.settings.appSettings.classes.noClassFound")}
        </div>
      )}
      {data?.content?.[0] && (
        <HostedPagesClassCard
          calendarEventOccurrence={{
            ...data?.content?.[0],
            bookedCount: Math.max((data?.content?.[0].capacity ?? 0) - 2, 0),
          }}
          disabled
          classesCapacityShowMode={classesLocalData.classesCapacityShowMode}
          className="w-full max-lg:max-w-md"
        />
      )}
    </div>
  );
};
